var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.997 13.1748C3.684 13.1748 0 13.8548 0 16.5748C0 19.2958 3.661 19.9998 7.997 19.9998C12.31 19.9998 15.994 19.3208 15.994 16.5998C15.994 13.8788 12.334 13.1748 7.997 13.1748Z",
    fill: "url(#paint0_linear_343_2181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.99708 10.584C10.9351 10.584 13.2891 8.229 13.2891 5.292C13.2891 2.355 10.9351 0 7.99708 0C5.06008 0 2.70508 2.355 2.70508 5.292C2.70508 8.229 5.06008 10.584 7.99708 10.584Z",
    fill: "url(#paint1_linear_343_2181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_2181",
    x1: 3.00465,
    y1: 13.1748,
    x2: 11.8696,
    y2: 19.3704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_2181",
    x1: 4.6934,
    y1: -2.24688e-7,
    x2: 12.7119,
    y2: 2.39137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.88c064c66c93fd3595e384bc103d4fdd.svg";
export { ForwardRef as ReactComponent };